/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_financialAmount = {|
  +amount: ?number;
  +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  +convertedAmountList: ?$ReadOnlyArray<?{|
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    +amount: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_financialAmount",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "amount",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FinancialAmount"
};

module.exports = fragment;
